import React from "react";
import TemplatesGalleryLazyLoad from "./TemplatesGalleryLazyLoad";
import { TemplatesGalleryProps } from "./TemplatesGallery";

const TemplatesGalleryComponent: React.FC<TemplatesGalleryProps> = (
  props: TemplatesGalleryProps
) => {
  return (
    <TemplatesGalleryLazyLoad
      productId={props.productId}
      mpvId={props.mpvId}
      locale={props.locale}
    />
  );
};

export default TemplatesGalleryComponent;
